import {
  LOGGED_IN,
  SET_AUTH_TOKEN,
  MENU_OPEN,
  SET_THEME_MODE,
  SET_METRICS_FILTERS,
  SET_METRICS_HAS_APPLIED,
  SET_COMPARISON_FILTERS,
  SET_ACCURACY_RANKING_FILTERS,
  SET_ACCURACY_RANKING_HAS_APPLIED
} from './action-types';

const serializeDate = (value) => {
  if (value == null) return null;
  if (typeof value === 'string') return value;
  if (typeof value.format === 'function' && value.isValid?.()) {
    return value.format('YYYY-MM-DD');
  }
  return null;
};

const serializeDateTime = (value) => {
  if (value == null) return null;
  if (typeof value === 'string') return value;
  if (typeof value.format === 'function' && value.isValid?.()) {
    return value.format('YYYY-MM-DDTHH:mm:ss');
  }
  return null;
};

const serializeComparisonSelection = (selection = {}) => ({
  turbine_data_id: selection.turbine_data_id ?? null,
  forecast_config_id: selection.forecast_config_id ?? null,
  prod_forecast_id: selection.prod_forecast_id ?? null
});

export const set_logged_in = (payload) => {
  return {
    type: LOGGED_IN,
    payload
  };
};

export const set_auth_token = (payload) => {
  return {
    type: SET_AUTH_TOKEN,
    payload
  };
};

export const set_menu_open = (payload) => {
  return {
    type: MENU_OPEN,
    id: payload
  };
};

export const set_theme_mode = (payload) => {
  return {
    type: SET_THEME_MODE,
    navType: payload
  };
};

export const set_metrics_filters = (filters) => ({
  type: SET_METRICS_FILTERS,
  payload: {
    location_id: filters.location_id ?? null,
    turbine_data_id: filters.turbine_data_id ?? null,
    forecast_config_ids: filters.forecast_config_ids ?? [],
    metric_id: filters.metric_id ?? null,
    horizon: filters.horizon ?? null,
    aggregation: filters.aggregation ?? '',
    from: serializeDate(filters.from),
    to: serializeDate(filters.to)
  }
});

export const set_metrics_has_applied = (payload) => ({
  type: SET_METRICS_HAS_APPLIED,
  payload
});

export const set_comparison_filters = (filters) => ({
  type: SET_COMPARISON_FILTERS,
  payload: {
    from: serializeDateTime(filters.from),
    to: serializeDateTime(filters.to),
    calculated: filters.calculated ?? 'all',
    location_id: filters.location_id ?? null,
    selection1: serializeComparisonSelection(filters.selection1),
    selection2: serializeComparisonSelection(filters.selection2)
  }
});

export const set_accuracy_ranking_filters = (filters) => ({
  type: SET_ACCURACY_RANKING_FILTERS,
  payload: {
    location_id: filters.location_id ?? null,
    turbine_data_id: filters.turbine_data_id ?? null,
    metric_id: filters.metric_id ?? null,
    compare_metric_id: filters.compare_metric_id ?? null,
    compare_turbine_data_id: filters.compare_turbine_data_id ?? null,
    from: serializeDate(filters.from),
    to: serializeDate(filters.to)
  }
});

export const set_accuracy_ranking_has_applied = (payload) => ({
  type: SET_ACCURACY_RANKING_HAS_APPLIED,
  payload
});
